<template>
  <div class="pl20 pr20">
    <div class="flex column relative" :style="{height:clientHeight-210+'px'}">
      <p class="fs20 bold flex jcc relative">{{ docInfo.hosName }}</p>
      <p class="fs16 mt10 flex jcc">处方笺</p>
      <p>
        <span class="sign signC" v-if="subStatus">已提交</span>
        <span class="sign" v-else>未提交</span>
      </p>
      <div class="patInfo flex column mb15 pt10 pb10 mt10">
        <!--<div>处方单号：{{sub? '': patientInfo.orderNo?patientInfo.orderNo:currentRecipe.orderNo}}</div>-->
        <div class="pl20 mt16 color_333">
          患者信息：{{ patientInfo.compatName }} {{ patientInfo.compatGender|sexFilter }}
          <span v-if="patientInfo.compatAge">{{ patientInfo.compatAge }}岁</span>
          {{ patientInfo.compatMobile }}
        </div>
        <div class="flex pl20 pr20 mt15">
          <span class="flex0 info-label pt5">诊断：</span>
          <!-- <span v-if="!diagnosisShow" class="info-item width20 ellipsis"
                 @click="diagnosisShow = !diagnosisShow">{{diagnosis}}</span>-->
          <el-autocomplete
              class="flex1"
              size="mini"
              type="textarea"
              style="z-index: 2006"
              autosize
              placeholder="按诊断名称或拼音首字母搜索"
              ref="zdEl"
              v-model="diagnosis"
              @blur="blurDiagnosis"
              :fetch-suggestions="fetchDiagnosis"
              @select="(item)=>{selectDiagnose(item)}"
              @keydown.native="deleteDiagnosis"
          >
            <template slot-scope="{item}">
              <div class="flex">
                <span class="flex1">{{ item.diagnosis }}</span>
                <a class="flex0 ml5 color_main" @click.stop="top(item)">{{ item.top ? '取消置顶' : '置顶' }}</a>
                <a class="flex0 ml5 color_main" @click="tag(item)">{{ item.tag ? '取消标签' : '标签' }}</a>
              </div>
            </template>
          </el-autocomplete>
        </div>
        <div class="pl20 pr20 pt15">
          <span class="fs12">标签：</span>
          <el-tag v-for="(t,i) in tags" size="mini" closable :key="i" style="margin-right: 5px" @click="handlerTag(t)"
                  @close="closeTag(t)">
            {{ t.diagnosis }}
          </el-tag>
        </div>
      </div>
      <div class="flex space-between aic">
        <div class="fs20 flex aic">
          {{ orderType === 'WESTERN_RECIPE' ? '西药处方' : '中药处方' }}
          <p class="fs16 pl10" v-if="orderType === 'CHINESE_RECIPE' && currentRecipe.drugList">
            ( 共{{ currentRecipe.drugList.length }}味
            <!--<span v-if="sumPerMount">、{{sumPerMount}}{{currentRecipe.drugList[0].dosageUnit}}</span>-->
            <span v-if="sumPrice">、共{{ sumPrice }}元</span>
            )
          </p>
        </div>
        <el-row>
          <el-button type="primary" plain size="medium" @click="medicineAdd">+添加药品</el-button>
        </el-row>
      </div>
      <recipe-west v-if="orderType==='WESTERN_RECIPE'"
                   :type="orderType"
                   :info="currentRecipe"
                   :drugAdmissionList="drugAdmissionList"
                   :drugFrequencyList="drugFrequencyList"
                   @medicineAdd="medicineAdd"
                   @handleSelect="handleSelect"
                   @medicineDelete="medicineDelete">
      </recipe-west>
      <recipe-zhongyao v-else
                       :type="orderType"
                       :info="currentRecipe"
                       :drugAdmissionList="drugAdmissionList"
                       :drugFrequencyList="drugFrequencyList"
                       :perMount="sumPerMount"
                       :price="sumPrice"
                       @medicineAdd="medicineAdd"
                       @handleSelect="handleSelect"
                       @medicineDelete="medicineDelete">
      </recipe-zhongyao>
    </div>
    <!--处方单号 开方医生 审方医生-->
    <div class="mt15 flex" :class="{'flex-end':orderType==='WESTERN_RECIPE'}">
      <ul v-if="orderType==='CHINESE_RECIPE'" class="flex1 flex column space-around mb10">
        <li class="flex aic mt5">
          <span class="flex0 info-label">类型：</span>
          <el-select v-model="currentRecipe.dosageForm" placeholder="请选择" size="mini"
                     class="flex0 width10">
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
          </el-select>

          <span class="flex0 ml10 info-label">用药方法：</span>
          <el-select v-model="tcmMethodCode" size="mini">
            <el-option v-for="method in chineseDrugAdmissionList"
                       :key="method.id"
                       :value="method.id"
                       :label="method.dictValue"
            ></el-option>
          </el-select>

          <span class="flex0 ml10 info-label">用药频率：</span>
          <el-select v-model="tcmFrequencyCode" size="mini">
            <el-option v-for="method in chineseDrugFrequencyList"
                       :key="method.id"
                       :value="method.id"
                       :label="method.dictValue"
            ></el-option>
          </el-select>
        </li>
        <li class="mt5">
          <span class="flex0 info-label">贴数：</span>
          <span class="flex0 width10">
                         <input v-model="currentRecipe.tcmDosage" type="number"
                                max="100" min="0" class="tcmDosageInput"/>
                    </span>
        </li>
        <li class="flex aic mt5 pr40 ">
          <span class="flex0 info-label">服用方法：</span>
          <!-- <span class="info-item width40"
                 v-if="!tcmAdmissionShow"
                 @click="tcmAdmissionShow = !tcmAdmissionShow">{{tcmAdmission}}</span>-->
          <el-input size="mini" v-model="tcmAdmission"
                    @change="changeTcmAdmission(tcmAdmission)"
                    @blur="tcmAdmissionBlur"
                    autofocus>
          </el-input>
        </li>
        <li class="flex aic mt5 pr40 ">
          <span class="flex0 info-label">处方备注：</span>
          <!-- <span class="info-item width40"
                 v-if="!tcmAdmissionShow"
                 @click="tcmAdmissionShow = !tcmAdmissionShow">{{tcmAdmission}}</span>-->
          <el-input size="mini" v-model="remark"></el-input>
        </li>
      </ul>
      <div class="width20 flex0 pt20 right">
        <p class="color_333 fs14">开方医生：{{ userInfo.docName }}</p>
        <el-row class="mt20 mr10">
          <el-button type="primary" size="medium" @click="handler('提交处方')">
            {{ sub ? '重新提交处方' : '提交处方' }}
          </el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeZhongyao from "./recipe-zhongyao";
import RecipeWest from "./recipe-west";
import {timeFormat} from "../../lib/utils";
import {tokenCache} from "../../lib/cache/Token"
import {loginInfoCache} from "../../lib/cache/LoginInfo"
import {accAdd, accMul, sexFilter} from "../../lib/filters";
import {recipeService} from "@/lib/service/recipe";

export default {
  name: "recipe-info",
  filters: {
    sexFilter
  },
  components: {RecipeWest, RecipeZhongyao},
  data() {
    return {
      userInfo: loginInfoCache.get().doc,
      currentRecipe: {},
      orderType: '',  //'CHINESE_RECIPE' : 'WESTERN_RECIPE'
      patientInfo: {},
      subStatus: false,
      sub: false,
      // diagnosisShow: false,
      allergyHistoryShow: false,
      tcmAdmissionShow: false,
      typeOptions: [{value: '选项1', label: '饮片'}], //中药有两种类型 饮片或者颗粒
      tcmAdmission: '',
      tcmMethodCode: '',
      tcmFrequencyCode: '',
      remark: '',
      diagnosis: "",
      diagnosisTemp: "",
      sumPerMount: '', //中药剂量总和
      sumPrice: '', //中药价格总和
      tags: [],
      dict: {}
    }
  },
  props: {
    info: Object,
    patient: Object,
    drugAdmissionList: Array,
    drugFrequencyList: Array,
    type: String,
    subs: Boolean,
    re: Boolean,
    su: Boolean,
    tcmAdmissions: String,
  },
  computed: {
    currDate() {
      const tDate = new Date()
      return timeFormat(tDate, "%Y/%m/%d")
    },
    clientHeight() {
      return (document.documentElement.clientHeight - 1 || document.body.clientHeight - 1) - 110
    },
    chineseDrugAdmissionList() {
      return this.dict.chineseDrugAdmissionList || []
    },
    chineseDrugFrequencyList() {
      return this.dict.chineseDrugFrequencyList || []
    }
  },
  created() {
    this.getTags()
    this.getDict()
  },
  methods: {
    closeTag(data) {
      this.$confirm('是否取消设置该标签?')
          .then(async () => {
            const code = await recipeService.diagnosisCancelTag(data.id)
            code === '0' && this.$message.success('取消标签成功')
            await this.getTags();
          })
    },
    handlerTag(data) {
      this.diagnosis = data.diagnosis;
      this.selectDiagnose(data);
    },
    async getTags() {
      this.tags = await recipeService.diagnosisDocList();
    },

    // 获取中药的用法和频率
    async getDict() {
      this.dict = await recipeService.drugDict();
    },

    async top({top, id}) {
      let code
      if (top) {
        code = await recipeService.diagnosisCancelTop(id)
        code === '0' && this.$message.success('取消置顶成功')
        top = false;
      } else {
        code = await recipeService.diagnosisTop(id);
        code === '0' && this.$message.success('置顶成功')
        top = true
      }
      this.$refs.zdEl.focus();
    },
    async tag({tag, id}) {
      let code
      if (tag) {
        code = await recipeService.diagnosisCancelTag(id)
        code === '0' && this.$message.success('取消标签成功')
      } else {
        code = await recipeService.diagnosisTag(id);
        code === '0' && this.$message.success('设置标签成功')
      }
      this.$refs.zdEl.focus();
      await this.getTags();
    },
    //价格格式化
    formatter(data) {
      let price = data.dosage ? accMul(data.price, data.dosage) / 100 : 0;
      let position = String(price).indexOf(".") + 1; //获取小数点的位置
      let count = String(price).length - position; //获取小数点后的个数
      if (position > 0 && count > 2) {
        return accAdd(String(price).substring(0, position + 2), 0.01);
      } else {
        return price;
      }
    },
    getSum() {
      let sumDosage = 0
      let sumPrice = 0
      if (this.currentRecipe && this.currentRecipe.drugList) {
        this.currentRecipe.drugList.forEach((item) => {
          sumDosage += Number(item.dosage)
          sumPrice += Number(this.formatter(item)) * 100
        })
        this.sumPerMount = sumDosage
        this.sumPrice = sumPrice / 100
      }
    },
    handler(name, type) {
      if (this.updateCurrentRecipe())
        this.$emit('handler', name, type)
    },
    updateCurrentRecipe() {
      const {tcmMethodCode, tcmFrequencyCode, remark} = this;
      if (!tcmMethodCode || !tcmFrequencyCode) {
        this.$message.error('用药方法或用药频率不能为空');
        return false;
      }
      const tcmMethodName = this.chineseDrugAdmissionList.find(r => r.id === tcmMethodCode).dictValue;
      const tcmFrequencyName = this.chineseDrugFrequencyList.find(r => r.id === tcmFrequencyCode).dictValue;
      this.$emit('updateCurrentRecipe', {tcmMethodCode, tcmMethodName, tcmFrequencyCode, tcmFrequencyName, remark});
      return true;
    },
    changeTcmAdmission(value) {
      this.$emit('changeTcmAdmission', value)
    },
    tcmAdmissionBlur() {
      this.tcmAdmissionShow = !this.tcmAdmissionShow
    },
    medicineDelete(r) {
      this.$emit('medicineDelete', r)
    },
    handleSelect(item, index) {
      this.$emit('handleSelect', item, index)
    },
    medicineAdd() {
      this.$emit('medicineAdd')
    },
    selectDiagnose(item) {
      console.log('之前的诊断===', this.diagnosisTemp)
      console.log('选择的诊断===', item)
      if (this.diagnosisTemp != '') {
        let list = this.diagnosisTemp.split(',')
        //限制诊断数量
        if (list.length < 200) {
          if (list.includes(item.diagnosis)) {
            this.$message.error('请勿重复选择诊断！')
            console.log(this.diagnosisTemp)
            console.log(this.diagnosis)
          } else {
            this.diagnosisTemp = this.diagnosisTemp + item.diagnosis + ','
          }
        } else {
          this.$message.error('输入诊断数量不能超过5个！')
        }
      } else {
        this.diagnosisTemp = this.diagnosis = this.diagnosis + ','
      }
      this.diagnosis = this.diagnosisTemp
      this.changeDiagnosis()
    },
    changeDiagnosis() {
      this.$emit('changeDiagnosis', this.diagnosis)
    },
    deleteDiagnosis(e) {
      if (e.keyCode == 8) {
        const o = this.diagnosis.split(',')
        o.splice(o.length - 2, 2)
        let n = o.length >= 1 ? o.join(",") + ',' : o.join(",")
        this.diagnosis = this.diagnosisTemp = n
      }
    },
    blurDiagnosis() {
      let name = this.diagnosis
      if (name.substr(name.length - 1, 1) === ',') return
      let list = this.diagnosis.split(',')
      let re = list.slice(0, list.length - 1)
      let res = re.length >= 1 ? re.join(",") + ',' : re.join(",")
      this.diagnosis = res
      this.diagnosisTemp = this.diagnosis
    },
    async fetchDiagnosis(queryString, cb) {
      let newQuery = queryString + ','
      if (newQuery === this.diagnosisTemp) {
        queryString = newQuery
        this.diagnosis = this.diagnosisTemp
      }
      const index = queryString.lastIndexOf(',')
      const key = queryString.substring(index + 1, queryString.length);
      const options = {
        diagnosis: key,
        token: tokenCache.get(),
      }
      let {code, list} = await this.$http("smarthos.recipe.diagnosis.list", options)
      if (code == '0') {
        for (let i of list) {
          i.value = i.diagnosis; //必须绑定value值作为显示数据
        }
        cb(list);
      }
    },
  },
  watch: {
    info: {
      handler(newV) {
        this.currentRecipe = newV
        this.diagnosis = newV.diagnosis
        this.getSum()
      },
      deep: true,
      immediate: true
    },
    type: {
      handler(newV) {
        this.orderType = newV
      },
      immediate: true
    },
    patient: {
      handler(newV) {
        this.patientInfo = newV
      },
      immediate: true
    },
    subs: {
      handler(newV) {
        this.subStatus = newV
      },
      immediate: true
    },
    su: {
      handler(newV) {
        this.sub = newV
      },
      immediate: true
    },
    tcmAdmissions: {
      handler(newV) {
        this.tcmAdmission = newV
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.patInfo {
  background-color: #f5f5f5;
  height: auto;
}

.sign {
  width: 65px;
  height: 25px;
  position: absolute;
  top: 15px;
  left: 70px;
  color: white;
  background-color: red;
  border-radius: 2px;
  text-align: center;
  transform: rotateZ(-30deg);
}

.signC {
  background-color: #ffffff;
  border: 1px solid #58A4FA;
  color: #58A4FA;
}

.info-label {
  font-size: 14px;
  color: #333333;
}

.info-item {
  font-size: 14px;
  color: #666666;
  margin-right: 60px;
  border-bottom: 1px solid #333333;
  padding: 0 10px;
}
</style>
